import React from 'react';
import Props from '../../Components/Props';
import FormikFields from 'components/FormikFields';
import JSXCode from '../../Components/JSXCode';
import { Form, Formik } from 'formik';

const TabDateRange = (props) => {
  //! State

  //! Function

  //! Render
  return (
    <div className='component:TabDateRange'>
      <Formik initialValues={{ dateRange: { from: '', to: '' } }} onSubmit={() => {}}>
        {({ values }) => {
          return (
            <Form>
              <code className='tw-block tw-mb-3'>{JSON.stringify(values)}</code>

              <div className='tw-flex tw-gap-4'>
                <FormikFields.DateRange name='dateRange' label='Date range' required />
              </div>
            </Form>
          );
        }}
      </Formik>

      <div className='tw-mt-3'>
        <JSXCode
          code={`<Formik initialValues={{ dateRange: { from: '', to: '' } }} onSubmit={() => {}}>
{() => {
    return (
    <Form>
        <code className='tw-block tw-mb-3'>{JSON.stringify(values)}</code>

        <div className='tw-flex tw-gap-4'>
            <FormikFields.DateRange name='dateRange' label='Date range' required />
        </div>
    </Form>
    );
}}
</Formik>
`}
        />
      </div>

      <Props
        className='tw-mt-5'
        source={[
          {
            prop: 'name',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'label',
            type: 'any',
            default: 'undefined',
          },
          {
            prop: 'placeholder',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'afterOnChange',
            type: '(dateRange) => void',
            default: 'undefined',
          },
          { prop: 'classNameContainer', type: 'string', default: 'undefined' },
          { prop: 'required', type: 'boolean', default: 'false' },
          { prop: 'isClearable', type: 'boolean', default: 'false' },
          { prop: 'disableSelectTime', type: 'boolean', default: 'false' },
          { prop: 'disableSelectMinutes', type: 'boolean', default: 'false' },
        ]}
      />
    </div>
  );
};

export default TabDateRange;
